import React from 'react';
import { Error } from 'Core/routes/Error';
import { Platform } from 'Core/routes/Platform';
import { NotFound } from 'Core/routes/NotFound';

export const errorPath = '/error';
export const platformPath = '/platform';

export const routes = [
  {
    path: errorPath,
    element: <Error />,
  },
  {
    path: platformPath,
    element: <Platform />,
  },
  {
    path: '*',
    element: <NotFound />,
  },
];
